<template>
  <v-expansion-panels flat class="flat-expanssion-panel">
    <v-expansion-panel>
      <v-expansion-panel-header ripple color="grey lighten-4" class="accent--text">
        {{ $t("natural-hazards") }}
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-simple-table dense>
          <template v-slot:default>
            
            <tbody>
              <tr>
                <td>{{ $t("fall-hazard") }}</td>
                <td>{{ plotItem.HAZ_FAL }}</td>
              </tr>
              <tr>
                <td>{{ $t("avalanche-hazard") }}</td>
                <td>{{ plotItem.HAZ_LAV }}</td>
              </tr>
              <tr>
                <td>{{ $t("slip-hazard") }}</td>
                <td><b>{{ plotItem.HAZ_SLI }}</b></td>
              </tr>
              <tr>
                <td>{{ $t("water-hazard") }}</td>
                <td><b>{{ plotItem.HAZ_WAT }}</b></td>
              </tr>
              <tr>
                <td>{{ $t("sinkhole-hazard") }}</td>
                <td>{{ plotItem.HAZ_DOL }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator"

@Component({
  components: {},
})
export default class ViewPlotDetails300 extends Vue {
  @Prop()
  plotItem
}
</script>

